<template>
  <div class="header">
    <div class="header_title">
      <p class="title">
        {{ title }}
      </p>
      <div class="content">
        {{ content }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String },
    content: { type: String }
  },
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.header {
  background-image: url('~@/assets/securityServices/banner.png');
  background-size: 100% 100%;
  padding-bottom: 190px;
  margin-top: -20px;
  background-repeat: no-repeat;
  background-position: center;
  height: 510px;

  .header_title {
    width: 40%;
    margin-left: 15%;
    padding-top: 65px;
    color: #333333;

    .title {
      font-size: 54px;
      font-weight: bold;
    }

    .content {
      font-size: 30px;
      color: #333333;
      line-height: 50px;
    }
  }
}

@media (min-width: 750px)and (max-width: 1250px) {
  .header .header_title .title {
    font-size: 30px;
  }

  .header .header_title .content {
    font-size: 20px;
  }
}

@media (min-width: 1200px)and (max-width: 1350px) {
  .header .header_title .title {
    font-size: 35px;
    margin: 25px 0;
  }

  .header .header_title .content {
    font-size: 20px;
    line-height: 40px;
  }

  .header{
    height: 255px;
  }

  .header .header_title  {
    padding-top: 35px;
    width: 45%;
  }
}

@media (min-width: 1350px)and (max-width: 1500px) {
  .header .header_title .title {
    font-size: 35px;
    margin: 20px 0;

  }
  .header .header_title  {
    padding-top: 35px;
    width: 40%;
  }

  .header .header_title .content {
    font-size: 22px;
    line-height: 40px;
  }
  .header{
    height: 285px;
  }

}

@media (min-width: 1500px)and (max-width: 1700px) {
  .header .header_title .title {
    font-size: 43px;
    margin: 30px 0;

  }

  .header .header_title .content {
    font-size: 25px;
  }

  .header{
    height: 350px;
  }

  .header .header_title  {
    padding-top: 35px;
  }
}</style>
